import { Link } from 'react-router-dom';

interface MangaCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  views: number;
  chapters: number;
  status: string;
  tags: string[];
  category: string;
}

function formatViews(views: number): string {
  if (views >= 10000) {
    return (views / 10000).toFixed(1) + '万';
  }
  return views.toString();
}

export default function MangaCard({
  id,
  title,
  author,
  cover,
  rating,
  views,
  chapters,
  status,
  tags,
  category,
}: MangaCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[5/7] mb-3">
        <img
          src={cover}
          alt={`${title} - 虫虫漫画韩国漫画`}
          title={`${title} - 韩国漫画在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <div className="w-full">
            <div className="flex flex-wrap gap-1">
              {tags.slice(0, 3).map((tag) => (
                <span
                  key={tag}
                  className="text-xs px-2 py-0.5 rounded-full bg-background-50/20 text-background-50 backdrop-blur-sm whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="absolute top-2 left-2">
          <span
            className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
              status === '连载中'
                ? 'bg-primary-500 text-background-50'
                : 'bg-secondary-500 text-background-50'
            }`}
          >
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-50/90 backdrop-blur-sm rounded-full px-2 py-0.5">
          <i className="ri-star-fill text-xs text-accent-500 w-3 h-3 flex items-center justify-center"></i>
          <span className="text-xs font-semibold text-foreground-800">{rating}</span>
        </div>
      </div>

      <h3 className="text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 mb-1">
        {title}
      </h3>
      <p className="text-xs text-foreground-500 mb-1">{author}</p>
      <div className="flex items-center gap-3 text-xs text-foreground-400">
        <span className="flex items-center gap-1">
          <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
          {formatViews(views)}
        </span>
        <span>{chapters}话</span>
      </div>
    </Link>
  );
}